import i18n from "@/i18n";

const routes = {
  path: "/swing",
  name: "Swing",
  component: () => import(/* webpackChunkName: "swing" */ "@/views/swing/Main"),
  children: [
    {
      path: "list",
      alias: "",
      name: "SwingList",
      component: () =>
        import(/* webpackChunkName: "swing" */ "@/views/swing/List"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.swing.swing_list"),
        step: [i18n.t("menu.swing.swing"), i18n.t("page.swing.swing_list")],
        menu_num: 6,
        location: "/swing/list",
      },
    },
    {
      path: "view/:id",
      name: "SwingView",
      component: () =>
        import(/* webpackChunkName: "swing" */ "@/views/swing/View"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.swing.swing_view"),
        step: [i18n.t("menu.swing.swing"), i18n.t("page.swing.swing_view")],
        menu_num: 6,
        location: "/swing/list",
      },
    },
  ],
};

export default routes;
